import { ChatbotPreview } from '..';

function ChatbotWidget() {
  return <ChatbotPreview />;
}

export default ChatbotWidget;
